"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManualAddress = ManualAddress;

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _postalAddressTypeList = require("../../siteContent/postalAddressTypeList");

var _addressValidator = require("./addressValidator");

var _auStateList = require("../../siteContent/auStateList");

var _streetTypeList = require("../../siteContent/streetTypeList");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ManualAddress(props) {
  var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;

  var name = props.name,
      values = props.values,
      allowPO = props.allowPO,
      testId = props.testId,
      country = props.country,
      allowPropertyName = props.allowPropertyName,
      addressValidator = props.addressValidator,
      streetTypeOptions = props.streetTypeOptions,
      cantFindAutoAddress = props.cantFindAutoAddress;
  var COUNTRY = country;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, allowPO && /*#__PURE__*/_react["default"].createElement(_basis.Select, {
    name: "".concat(name, ".postalAddressType"),
    label: "Postal address type",
    placeholder: "Please select",
    options: _postalAddressTypeList.postalAddressTypeOptions,
    validate: cantFindAutoAddress && ((_ref = addressValidator && addressValidator.postalAddressStyleValidation) !== null && _ref !== void 0 ? _ref : _addressValidator.postalAddressStyleValidation),
    testId: "".concat(testId, "-postal-address-type")
  }), (!allowPO || allowPO && values.postalAddressType === 'Street-address-Type') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".unitNumber"),
    label: "Unit number",
    validate: cantFindAutoAddress && ((_ref2 = addressValidator && addressValidator.unitAddressValidation) !== null && _ref2 !== void 0 ? _ref2 : _addressValidator.unitAddressValidation),
    optional: true,
    testId: "".concat(testId, "-unit-number")
  }), /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".streetNumber"),
    label: "Street number",
    validate: cantFindAutoAddress && ((_ref3 = addressValidator && addressValidator.streetNumberAddressValidation) !== null && _ref3 !== void 0 ? _ref3 : _addressValidator.streetNumberAddressValidation),
    testId: "".concat(testId, "-street-number")
  }), /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".streetName"),
    label: "Street name",
    validate: cantFindAutoAddress && ((_ref4 = addressValidator && addressValidator.streetNameAddressValidation) !== null && _ref4 !== void 0 ? _ref4 : _addressValidator.streetNameAddressValidation),
    testId: "".concat(testId, "-street-name")
  }), /*#__PURE__*/_react["default"].createElement(_basis.Select, {
    name: "".concat(name, ".streetType"),
    label: "Street type",
    placeholder: "Please select",
    options: streetTypeOptions !== null && streetTypeOptions !== void 0 ? streetTypeOptions : _streetTypeList.streetTypeDefaultOptions,
    validate: cantFindAutoAddress && ((_ref5 = addressValidator && addressValidator.streetTypeValidation) !== null && _ref5 !== void 0 ? _ref5 : _addressValidator.streetTypeValidation),
    testId: "".concat(testId, "-street-type")
  })), allowPO && values.postalAddressType === 'PO-Box-Type' && /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".poBoxNumber"),
    label: "PO Box",
    validate: cantFindAutoAddress && ((_ref6 = addressValidator && addressValidator.poBoxValidation) !== null && _ref6 !== void 0 ? _ref6 : _addressValidator.poBoxValidation),
    testId: "".concat(testId, "-po-box-number")
  }), (!allowPO || allowPO && values.postalAddressType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".suburb"),
    label: COUNTRY === 'AU' ? 'Suburb' : 'Suburb / Rural delivery number',
    required: COUNTRY === 'AU',
    validate: cantFindAutoAddress && ((_ref7 = addressValidator && addressValidator.suburbAddressValidation) !== null && _ref7 !== void 0 ? _ref7 : _addressValidator.suburbAddressValidation),
    testId: "".concat(testId, "-suburb")
  }), COUNTRY === 'NZ' && /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".city"),
    label: "Town / City",
    validate: cantFindAutoAddress && ((_ref8 = addressValidator && addressValidator.cityAddressValidation) !== null && _ref8 !== void 0 ? _ref8 : _addressValidator.cityAddressValidation),
    testId: "".concat(testId, "-city")
  }), COUNTRY === 'AU' && /*#__PURE__*/_react["default"].createElement(_basis.Select, {
    name: "".concat(name, ".state"),
    label: "State",
    placeholder: "Please select",
    options: _auStateList.auStateOptions,
    validate: cantFindAutoAddress && ((_ref9 = addressValidator && addressValidator.auStateValidation) !== null && _ref9 !== void 0 ? _ref9 : _addressValidator.auStateValidation),
    testId: "".concat(testId, "-state")
  }), /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".postcode"),
    variant: "numeric",
    label: "Postcode",
    validate: cantFindAutoAddress && ((_ref10 = addressValidator && addressValidator.postcodeAddressValidation) !== null && _ref10 !== void 0 ? _ref10 : _addressValidator.postcodeAddressValidation),
    testId: "".concat(testId, "-postcode")
  }), allowPropertyName && /*#__PURE__*/_react["default"].createElement(_basis.Input, {
    name: "".concat(name, ".propertyName"),
    label: "Property name",
    validate: cantFindAutoAddress && ((_ref11 = addressValidator && addressValidator.propertyNameValidation) !== null && _ref11 !== void 0 ? _ref11 : _addressValidator.propertyNameValidation),
    testId: "".concat(testId, "-propertyName"),
    optional: true
  })));
}